import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["modal", "details", "reasons", "submitBtn", "copyBtn"]
  static values = { messageId: String, submitUrl: String }

  selectedReason = null

  openFeedback(event) {
    event.preventDefault()
    if (!this.hasModalTarget) return
    this.modalTarget.classList.remove("hidden")
    document.body.style.overflow = "hidden"
  }

  closeFeedback() {
    if (!this.hasModalTarget) return
    this.modalTarget.classList.add("hidden")
    document.body.style.overflow = ""
    this.resetForm()
  }

  selectReason(event) {
    this.selectedReason = event.target.value
    if (this.hasSubmitBtnTarget) {
      this.submitBtnTarget.disabled = false
    }
  }

  async submitFeedback() {
    if (!this.selectedReason) return

    const details = this.hasDetailsTarget ? this.detailsTarget.value.trim() : ""
    const correctionText = details || this.selectedReason.replace(/_/g, " ")

    if (this.hasSubmitBtnTarget) {
      this.submitBtnTarget.disabled = true
      this.submitBtnTarget.textContent = "Submitting..."
    }

    try {
      const response = await fetch(this.submitUrlValue, {
        method: "PATCH",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
          "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]')?.content,
          "Accept": "text/vnd.turbo-stream.html"
        },
        body: new URLSearchParams({
          correction_text: correctionText,
          feedback_reason: this.selectedReason,
          feedback_details: details
        })
      })

      if (response.ok) {
        const html = await response.text()
        Turbo.renderStreamMessage(html)
      }
    } catch (e) {
      console.error("Feedback submission failed:", e)
    }

    this.closeFeedback()
  }

  copySql() {
    const sqlEl = this.element.closest("[data-scroll-bottom-target]")
                    ?.querySelector("pre[data-sql-toggle-target='content']")
    if (sqlEl?.textContent) {
      navigator.clipboard.writeText(sqlEl.textContent.trim())
      if (this.hasCopyBtnTarget) {
        const btn = this.copyBtnTarget
        const svg = btn.querySelector("svg")
        svg.classList.remove("text-gray-400")
        svg.classList.add("text-emerald-500")
        setTimeout(() => {
          svg.classList.remove("text-emerald-500")
          svg.classList.add("text-gray-400")
        }, 1500)
      }
    }
  }

  resetForm() {
    this.selectedReason = null
    if (this.hasSubmitBtnTarget) {
      this.submitBtnTarget.disabled = true
      this.submitBtnTarget.textContent = "Submit"
    }
    if (this.hasDetailsTarget) {
      this.detailsTarget.value = ""
    }
    // Uncheck radio buttons
    this.element.querySelectorAll('input[type="radio"]').forEach(r => r.checked = false)
    // Reset label styles
    this.element.querySelectorAll('label').forEach(l => {
      l.classList.remove("border-purple-400", "bg-purple-50")
    })
  }
}
